/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import { NgModule } from "@angular/core";

import { FlexLayoutModule } from "@angular/flex-layout";

import { MatToolbarModule } from "@angular/material/toolbar";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatButtonModule } from "@angular/material/button";
import { MatGridListModule } from "@angular/material/grid-list";

import { AigiaRoutingModule } from "./aigia-routing.module";

import { ImageModule } from "../platform/image/image.module";
import { GuestsModule } from "./guests/guests.module";
import { Guests2Module } from "./guests2/guests2.module";
import { ShotdataModule } from "./shotdata/shotdata.module";
import { StaticvideoModule } from "./staticvideo/staticvideo.module";
import { AigiaAuthModule } from "./auth/aigia-auth.module";
import { TopModule } from "./top/top.module";
import { AigPipeModule } from "./base/pipes/aig-pipe.module";
import { BasePipeModule } from "../platform/base/pipes/base-pipe.module";

import { AigiaComponent } from "./aigia.component";
import { ProfileModule } from "./profile/profile.module";
import { Profile2Module } from "./profile2/profile2.module";
import { NewsModule } from "./news/news.module";
import { NewsDescriptionModule } from "./news/description/news.description.module";
import { CommonModule } from "@angular/common";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { PaymentModule } from "./payment/payment.module";
import { MessageDialogModule } from "./base/components/message-dialog/message-dialog.module";
import { InquiriesModule } from "./inquiry/inquiries.module";
import { ContactModule } from "./contact/contact.module";
import { HomeModule } from "./home/home.module";
import { YesNoDialogComponent } from "../platform/base/components/yes-no-dialog/yes-no-dialog.component";
import { MatCardModule } from "@angular/material/card";
import { YesNoDialogModule } from "../platform/base/components/yes-no-dialog/yes-no-dialog.module";

// i18n
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

export function HttpLoaderFactory(httpClient: HttpClient) {
	return new TranslateHttpLoader(httpClient, "./i18n/", ".json");
}
//

@NgModule({
	declarations: [AigiaComponent],
	imports: [
		CommonModule,

		FlexLayoutModule,

		MatToolbarModule,
		MatCardModule,
		MatSidenavModule,
		MatListModule,
		MatIconModule,
		MatButtonModule,
		MatMenuModule,
		MatSlideToggleModule,

		BasePipeModule,

		AigiaRoutingModule,
		AigPipeModule,
		MessageDialogModule,
		YesNoDialogModule,

		TopModule,
		AigiaAuthModule,
		GuestsModule,
		Guests2Module,
		ShotdataModule,
		StaticvideoModule,
		HomeModule,
		ProfileModule,
		Profile2Module,
		NewsModule,
		NewsDescriptionModule,
		PaymentModule,
		ImageModule,
		InquiriesModule,
		ContactModule,
		MatGridListModule,

		// i18n
		HttpClientModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		//
	],
	exports: [AigiaComponent],
	providers: [],
	bootstrap: [AigiaComponent, YesNoDialogComponent],
})
export class AigiaModule {}
